import { Device } from 'src/Libs/flow/installation/forms'

export const getHasNonEmcDevices = (devices: Device[]): boolean => {
  return devices.some(device => device.deviceCategory !== 'EMC')
}
